import { createSlice } from '@reduxjs/toolkit';

export const counterSlice = createSlice({
	name: 'auth',
	initialState: {
		accessToken: '',
		refreshToken: '',
		user: {},
		rememberData: {}
	},
	reducers: {
		setTokens: (state, action) => {
			state.accessToken = action.payload.accessToken;
		},
		setUser: (state, action) => {
			state.user = action.payload || {};
		},
		setRememberData: (state, action) => {
			state.rememberData = {
				login: action.payload.login || ''
			};
		},
		logout: (state, action) => {
			state.accessToken = '';
			state.refreshToken = '';
			state.user = {};
			state.rememberData = {};
		},
	},
});

export const { setTokens, setUser, setRememberData, logout } = counterSlice.actions;

export default counterSlice.reducer;
